export default __webpack_public_path__ + "static/media/Nexa-Light.2bac835e.otf";